import {Component, OnInit} from '@angular/core';
import { BlogService } from '../../services/blog.service';
import { TranslateService } from '@ngx-translate/core';
import { CommunicationService } from '../../services/communication.service';
import { StaticPathPipe } from '../../shared/pipes/static-path.pipe';
import {SCREEN_SIZE} from '../../classes/enums';
import {HasSubscriptions} from '../has-subscriptions';
import get from 'lodash-es/get';
import {MetaTagService} from "../../services/meta-tag.service";
import {HistoryItem} from "../../classes/history-item";
import {RoutingHistoryService} from "../../services/routing-history.service";

@Component({
  selector: 'app-home-estimates',
  templateUrl: './home-estimates.component.html',
  styleUrls: ['./home-estimates.component.scss', './home-estimates.desktop.component.scss']
})
export class HomeEstimatesComponent extends HasSubscriptions implements OnInit {
  screenSize: SCREEN_SIZE;
  showBannerStyle: any;
  bannerUrl: any;
  searchBarPlaceholder: string;
  teranetAboutUsLink: string;
  teranetOurDataLink: string;
  teranetSolutionsLink: string;
  showRequestSent: boolean = false;
  bannerDefaultUrl: string = '/assets/home-estimator/home-estimate-banner.jpg';
  private readonly aboutUsLink = 'https://www.teranet.ca/about-teranet';
  private readonly ourDataLink = 'https://ci23.actonsoftware.com/acton/attachment/2216/f-89f8b950-f070-4ac1-a622-403fc7e3d38a/0/-/-/-/-/AVM_Overview.pdf';
  private readonly solutionsLink = 'https://www2.geowarehouse.ca';

  constructor(
    private blogService: BlogService,
    private historyService: RoutingHistoryService,
    private communicationService: CommunicationService,
    private staticPathPipe: StaticPathPipe,
    private metaTagService: MetaTagService,
    private translateService: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.communicationService.footerLinksChange.next({city: null, province: null});
    this.addSub(this.communicationService.screenSize.subscribe((screenSize) => {
      this.screenSize = screenSize;
      this.showBannerStyle = this.addStyles();
      this.setPlaceholderText();
    }));

    this.blogService.getByTags(['cms-homeEstimator']).toPromise()
      .then((results) => {
        if (results) {
         const renderedJson = get(results, '[0].content.content.renderedAsJson', {});
         this.bannerUrl =  renderedJson.ImageUrl ? renderedJson.ImageUrl : this.bannerDefaultUrl;
         this.showBannerStyle = this.addStyles();
         const teranetPromotion = renderedJson ? renderedJson.TeranetPromotion : null;
         this.teranetAboutUsLink = teranetPromotion ? teranetPromotion.AboutUsUrl : this.aboutUsLink;
         this.teranetOurDataLink = teranetPromotion ? teranetPromotion.OurDataUrl : this.ourDataLink;
         this.teranetSolutionsLink = teranetPromotion ? teranetPromotion.SolutionsUrl : this.solutionsLink;
        }
    });

    this.setSEOItems();
    this.historyService.push(new HistoryItem ({ fromEstimateLandingPage: true, detailUrl: '/home-estimates-canada' }));
  }

  private setSEOItems() {
    const title = `home-estimator.meta-tags.title`;
    const description = `home-estimator.meta-tags.description`;

    this.metaTagService.setPageTitle(title, {});
    this.metaTagService.setPageDescription(description, {});

    const openGraphTags: any = [
      {
        name: 'title',
        content: title,
        variables: {},
        isTranslateKey: true
      },
      {
        name: 'description',
        content: description,
        variables: {},
        isTranslateKey: true
      }
    ];

    this.metaTagService.setOpenGraphTags(openGraphTags);
  }

  addStyles() {
    if (this.bannerUrl) {
      const statURL = this.staticPathPipe.transform(this.bannerUrl +  '?auto=compress,format&q=0');
      if (this.screenSize === SCREEN_SIZE.MOBILE_ONLY) {
        return {
          'background-image' : 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(' + statURL + ')'
        };
      }
      return {
        'background-image' : 'linear-gradient(rgba(0, 0, 0, 0) 66%, rgba(0, 0, 0, 0.5) 100%),url(' + statURL + ')'
      };
    }
  }

  setPlaceholderText() {
    const key = this.screenSize === SCREEN_SIZE.MOBILE_ONLY ? 'home-estimator.search-placeholder-mobile' : 'home-estimator.search-placeholder';
    this.translateService.get(key).toPromise().then((text) => this.searchBarPlaceholder = text);
  }

}
